<app-layout>
    <!--If Recruiter-->
    <app-recruiter-dashboard *ngIf="user_access > 1" class="col main pt-5 mt-3"></app-recruiter-dashboard>
    <!--If Interviewer-->
    <app-interviewer-dashboard *ngIf="user_access == 1" class="col main pt-5 mt-3"></app-interviewer-dashboard>
</app-layout>